// Shows a web push that arrives while the app is in front as an in-app notice,
// and tells the service worker it did, so the worker skips the system
// notification (lib/pushNotice.ts, issue 272).
//
// Mounted in AppShell beside <Toaster />, so a notice is only claimed where it
// can be seen. On the sign-in page nothing listens, the worker hears no answer,
// and it shows the system notification instead. Renders nothing.

import { useEffect } from 'react';

import { receivePushNotice } from '../lib/pushNotice';
import { showToast } from '../lib/toast';

/** Longer than an ordinary toast: time to read the notice and reach its link. */
const PUSH_NOTICE_DURATION_MS = 10_000;

export function PushNoticeListener() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const container = navigator.serviceWorker;
    const onMessage = (event: MessageEvent) => {
      receivePushNotice(event, (notice) =>
        showToast(notice.title, notice.body || undefined, {
          durationMs: PUSH_NOTICE_DURATION_MS,
          link: notice.link ? { href: notice.link, label: 'View' } : undefined,
        }),
      );
    };
    container.addEventListener('message', onMessage);
    return () => container.removeEventListener('message', onMessage);
  }, []);

  return null;
}
